













































































import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import SeparatorComponent from '@/shared/components/SeparatorComponent.vue'

@Component({
    name: 'datasecurity',
    components: {
        'ldw-separator': SeparatorComponent
    }
})

export default class TeamPage extends Vue {}
